import { message, Tag, Descriptions } from "antd";
import { LockOutlined } from "@ant-design/icons";
import axios from "axios";
import React, { Component } from "react";
import { connect } from "react-redux";
import { ModalItem, TablaEditor } from "../../../../Components/Items";
import moment from "moment";
import "moment/locale/es";

moment.locale("es");

class VerTabla extends Component {
    state = {
        loading: false,
        tabla: null,
        columnas: [],
        filas: [],
    };

    componentDidUpdate(prevProps) {
        if (prevProps.visible !== this.props.visible) {
            if (this.props.visible && this.props.tablaId) {
                this.setState({ tabla: null, columnas: [], filas: [] });
                this.consultarDatosTabla(this.props.tablaId);
            }
        }
    }

    consultarDatosTabla(id) {
        this.setState({ loading: true });
        axios
            .post("tablas/datosTabla", { tablaId: id, empresaId: this.props.empresaId }, { headers: this.props.headersToken })
            .then((res) => {
                this.setState({ loading: false });
                if (res.data.success !== 2) {
                    message.error("No se encontraron los datos de la tabla");
                } else {
                    const { columnas, filas, ...resto } = res.data.data;
                    const filasConKey = (filas || []).map((f, i) => ({ ...f, key: i }));
                    this.setState({ tabla: resto, columnas: columnas || [], filas: filasConKey });
                }
            })
            .catch(() => {
                this.setState({ loading: false });
                message.error("Error al comunicarse con el servidor");
            });
    }

    cerrarModal = () => {
        this.props.cerrarVerTabla();
        this.setState({ tabla: null, columnas: [], filas: [] });
    };

    render() {
        const { tabla, columnas, filas } = this.state;

        const titulo = tabla ? (
            <span>
                {tabla.nombre}
                {tabla.esSistema && (
                    <Tag color="gold" style={{ marginLeft: 8 }}>
                        <LockOutlined style={{ marginRight: 4 }} />Sistema
                    </Tag>
                )}
            </span>
        ) : "Ver Tabla";

        return (
            <ModalItem
                title={titulo}
                visible={this.props.visible}
                spinning={this.state.loading}
                onCancel={this.cerrarModal}
                width={1000}
                footer={null}
            >
                {tabla && (
                    <>
                        <Descriptions size="small" bordered column={3} style={{ marginBottom: 16 }}>
                            <Descriptions.Item label="Ejercicio">{tabla.ejercicio}</Descriptions.Item>
                            <Descriptions.Item label="Nombre Fórmula">
                                <span style={{ fontFamily: "monospace" }}>{tabla.nombreFormula || "—"}</span>
                            </Descriptions.Item>
                            <Descriptions.Item label="Vigencia">
                                {tabla.fechaInicioVigencia ? moment(tabla.fechaInicioVigencia).format("DD/MMM/YYYY") : "?"}
                                {" — "}
                                {tabla.fechaFinVigencia ? moment(tabla.fechaFinVigencia).format("DD/MMM/YYYY") : "?"}
                            </Descriptions.Item>
                            {tabla.descripcion && (
                                <Descriptions.Item label="Descripción" span={3}>{tabla.descripcion}</Descriptions.Item>
                            )}
                        </Descriptions>

                        <TablaEditor
                            columnas={columnas}
                            filas={filas}
                            onChange={() => { }}
                            readOnly
                        />
                    </>
                )}
            </ModalItem>
        );
    }
}

const mapStateToProps = (state) => ({
    headersToken: state.user.headersToken,
    empresaId: state.empresa.id,
});

export default connect(mapStateToProps)(VerTabla);